import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "mapToArray",
    standalone: false
})
/**
 * Convert generic map to array object (id, value)
 */
export class MapToArrayPipe implements PipeTransform {
  transform(map: Map<any, any>): any[] {
    let array = [];

    map.forEach((val, key) => {
      array.push({
        id: key,
        value: val,
      });
    });

    return array;
  }
}
